/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RevokeSessionRequestBody = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  sessionId: string;
};

/** @internal */
export type RevokeSessionRequestBody$Outbound = {
  agent_id: string;
  session_id: string;
};

/** @internal */
export const RevokeSessionRequestBody$outboundSchema: z.ZodMiniType<
  RevokeSessionRequestBody$Outbound,
  RevokeSessionRequestBody
> = z.pipe(
  z.object({
    agentId: z.string(),
    sessionId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      sessionId: "session_id",
    });
  }),
);

export function revokeSessionRequestBodyToJSON(
  revokeSessionRequestBody: RevokeSessionRequestBody,
): string {
  return JSON.stringify(
    RevokeSessionRequestBody$outboundSchema.parse(revokeSessionRequestBody),
  );
}
